import BigNumber from "bignumber.js";
export const serializePolkadotTransaction = ({ amount, recipient, family, mode, fee, era, }) => ({
    amount: amount.toString(),
    recipient,
    family,
    mode,
    fee: fee ? fee.toString() : undefined,
    era,
});
export const deserializePolkadotTransaction = ({ amount, recipient, family, mode, fee, era, }) => ({
    amount: new BigNumber(amount),
    recipient,
    family,
    mode,
    fee: fee ? new BigNumber(fee) : undefined,
    era,
});
//# sourceMappingURL=serializer.js.map